import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';

import { validEmail } from '../../../shared/regex';
import Field from '../../../ui/form-elements/Field';
import PhoneField from '../../../ui/form-elements/PhoneField/PhoneField';
import { TypeForm } from '../auth.interface';

interface IAuthFields {
  register: UseFormRegister<any>;
  formState: any;
  type: TypeForm;
}
const AuthFields: FC<IAuthFields> = ({ register, formState, type }) => {
  return (
    <>
      {type === 'phone' && <PhoneField />}

      {type === 'email' && (
        <Field
          {...register('email', {
            required: 'Почта обязательна',
            pattern: {
              value: validEmail,
              message: 'Некорректный формат почты',
            },
          })}
          label="Электронная почта"
          error={formState.errors.email}
        />
      )}

      {type === 'code' && (
        <Field
          {...register('code', {
            required: 'Код обязателен',
            pattern: {
              value: /^\d{4}$/,
              message: 'Неверный код',
            },
          })}
          label="Введите 4 цифры"
          error={formState.errors.code}
        />
      )}
    </>
  );
};

export default AuthFields;
